import { onValue, ref } from "firebase/database";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import mapData from "../data/mapData.json";
import { db } from "./firebase";

export default function useMapData(queryParam) {
  const [resultList, setResultList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubsribe = () => {
      if (process.env.NODE_ENV === "development") {
        console.log("development mode");
        setResultList(mapData.estateData);
      } else {
        console.log("production mode");
        let fetchResults;
        if (queryParam) {
          // console.log(queryParam);
          fetchResults = ref(db, `/all/${queryParam}`);
          // console.log(fetchResults);
          onValue(fetchResults, snapshot => {
            const data = snapshot.val();
            // console.log(data);
            if (!!data) {
              setResultList(data);
            } else {
              navigate("/", { replace: true });
              setResultList([]);
            }
          });
        } else {
          fetchResults = ref(db, `estateData`);
          onValue(fetchResults, snapshot => {
            const data = snapshot.val();
            setResultList(data);
          });
        }
      }
    };
    unsubsribe();
    return () => unsubsribe();
  }, [navigate, queryParam]);

  return resultList;
}
